import script from "./QuickpaySettingsFaq.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsFaq.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsFaq.vue?vue&type=style&index=0&id=10577af8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10577af8"]])

export default __exports__